import Vue from 'vue';
import {setAuthenticationHeaderAxios} from "@/plugins/axios";
import router from '../router';

const authentication = {
    namespaced: true,
    state: () => ({
        authenticated: false,
        loggedOut: false
    }),
    actions: {
        async setAuthentication({state, dispatch}, token) {
            Vue.$cookies.set(Vue.prototype.$JWT_COOKIENAME, token);

            state.authenticated = true;
            setAuthenticationHeaderAxios(token);

            await dispatch('user/fetchUser', null, {root: true});
        },
        redirectDefaultStartPage({rootGetters, rootState}) {
            if (rootGetters['user/currentLoggedInUser'].roles.includes("ROLE_ADMIN")) {
                router.push({name: 'landingPage'});
                rootState.loggedOut = false;
            } else {
                router.push({name: 'landingPage'});
                rootState.loggedOut = false;
            }
        },
        logoutFromApp({state, dispatch, rootState}) {
            Vue.$cookies.remove(Vue.prototype.$JWT_COOKIENAME);
            state.authenticated = false;
            setAuthenticationHeaderAxios();
            dispatch('user/clearUserData', null, {root: true})
                .then(() => {
                        router.push({name: 'login'});
                        rootState.loggedOut = true;
                    }
                );
        }
    },
    getters: {
        backendAuthenticated: state => state.authenticated,
        loggedOut: state => state.loggedOut
    }
};
export default authentication;
